import Cookies from 'js-cookie'
import Vue from 'vue'

export default{
    setToken: function () {
        Vue.http.headers.common['Authorization'] = 'JWT ' + Cookies.get('token')
    }
}



// WEBPACK FOOTER //
// ./src/generic/index.js